import type { SVGProps } from 'react';

function IconTrain(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M416 112C442.5 112 464 133.5 464 160L464 256L176 256L176 160C176 133.5 197.5 112 224 112L416 112zM128 256L128 416C128 456.1 152.6 490.5 187.5 504.8L133.7 568.5C125.1 578.6 126.4 593.8 136.5 602.3C146.6 610.8 161.8 609.6 170.3 599.5L244.3 512L395.6 512L469.6 599.5C478.2 609.6 493.3 610.9 503.4 602.3C513.5 593.7 514.8 578.6 506.2 568.5L452.3 504.8C487.4 490.5 512 456.1 512 416L512 160C512 107 469 64 416 64L224 64C171 64 128 107 128 160L128 256zM464 416C464 442.5 442.5 464 416 464L224 464C197.5 464 176 442.5 176 416L176 304L464 304L464 416zM320 416C337.7 416 352 401.7 352 384C352 366.3 337.7 352 320 352C302.3 352 288 366.3 288 384C288 401.7 302.3 416 320 416z"
                fill="currentColor"
            />
        </svg>
    );
}

export default IconTrain;
